import { FormControl } from '@angular/forms';

export function addStartEndDateCrossValidation(
  startDateControl: FormControl<string>,
  endDateControl: FormControl<string>
) {
  startDateControl.addValidators(function startDateValidator(control) {
    let invalid = control.value > endDateControl?.value;
    if (endDateControl?.invalid !== invalid) {
      setTimeout(() => endDateControl?.updateValueAndValidity(), 0);
    }
    if (invalid) {
      return {
        endDateBeforeStartDate: 'Start Date must be before End Date',
      };
    }
  });
  endDateControl.addValidators([
    function endDateValidator(control) {
      let invalid = control.value < startDateControl?.value;
      if (startDateControl?.invalid !== invalid) {
        setTimeout(() => startDateControl?.updateValueAndValidity(), 0);
      }
      if (invalid) {
        return {
          endDateBeforeStartDate: 'End Date must be after Start Date',
        };
      }
    },
    function endDateInPastValidator(control) {
      let invalid = control.value < new Date().toISOString();
      if (invalid) {
        return {
          endDateInPast: 'Please add a future return date',
        };
      }
    },
  ]);
}
